import { CanMatchFn, Router } from '@angular/router';
import { QueryClient } from '@tanstack/angular-query-experimental';
import { ProjectsQueryService } from '../projects/projects-query.service';
import { inject, signal } from '@angular/core';
import { ProfileService } from '../profile/profile.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { firstValueFrom } from '../shared/observable.utils';
import { filter } from 'rxjs';

/**
 * Checks if the user has permissions for the relevant project under the :projectId path parameter
 * or if they are a site admin actively in exhaustive mode.
 *
 * If not redirects to the "No Project Access" page
 */
export const projectAccessGuard: CanMatchFn = async (_, segments) => {

  const projectService = inject(ProjectsQueryService);
  const profileService = inject(ProfileService);
  const queryClient = inject(QueryClient);
  const router = inject(Router);

  const exhaustiveMode = toSignal(profileService.exhaustiveMode$);
  const profile = await firstValueFrom(profileService.profile$.pipe(filter(profile => Boolean(profile))));

  // !!! just manually grabbing the relvant route segment, might be fragile
  const projectId = segments[1].path;

  const project = await queryClient.ensureQueryData(projectService.getProjectQueryOptions(signal(projectId)))

  const userIsIncludedInProject = project.permissions.find(
    userWithProjectAccess => userWithProjectAccess._id === profile._id,
  );

  const hasAccess = Boolean(userIsIncludedInProject) || exhaustiveMode()

  return hasAccess || router.createUrlTree(['projects', projectId, 'no-access']);
}


